import { render, staticRenderFns } from "./COAEdit.vue?vue&type=template&id=6b666575&scoped=true&lang=pug"
import script from "./COAEdit.vue?vue&type=script&lang=js"
export * from "./COAEdit.vue?vue&type=script&lang=js"
import style0 from "./COAEdit.vue?vue&type=style&index=0&id=6b666575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b666575",
  null
  
)

export default component.exports